// Standalone layout without the main app navigation
export default [];
